// 출력물 장 나누기. DOM을 재지 않고 행 수로만 자른다.
//
// A4 세로 1면 기준(2026-08-21 가로 2면 → 세로 1면 변경). 머리글 구성이 같아
// 표 첫 행은 원본 PDF 실측대로 65.6mm에서 시작하고 행 높이 4.744mm.
// 297mm 세로에서 하단 여백(가로판 기준 ~7mm)을 빼면 (285.4-65.6)/4.744 ≈ 46.3
// → 여유를 두고 장당 46행. 소계행도 일반 행과 같이 1행을 차지한다.

import type {
  InvoiceDocumentGroup,
  InvoiceDocumentRow,
} from './invoice-document-types';

export const ROWS_PER_PAGE = 46;

export interface InvoiceSheetData {
  tableTitle: string;
  rows: InvoiceDocumentRow[];
}

/**
 * 그룹을 장 단위로 자른다.
 *
 * - 그룹 경계는 항상 장 경계다(유형 4·7의 유종별 별지).
 * - 총계는 마지막 그룹 끝에만 오므로 자동으로 마지막 장에 실린다.
 * - 총계가 마지막 장에 안 들어가면 넘치는 행 수만큼만 다음 장으로 내린다.
 *   이렇게 해야 원본 유형 7에서 발견된 "총계만 있는 빈 장"이 생기지 않는다.
 */
export function paginateDocument(
  groups: InvoiceDocumentGroup[]
): InvoiceSheetData[] {
  const sheets: InvoiceSheetData[] = [];

  for (const group of groups) {
    let cut = group.rows.length;
    while (cut > 0 && group.rows[cut - 1].rowType === 'grandTotal') {
      cut--;
    }
    const body = group.rows.slice(0, cut);
    const totals = group.rows.slice(cut);

    const chunks: InvoiceDocumentRow[][] = [];
    for (let i = 0; i < body.length; i += ROWS_PER_PAGE) {
      chunks.push(body.slice(i, i + ROWS_PER_PAGE));
    }
    if (chunks.length === 0) {
      chunks.push([]);
    }

    if (totals.length > 0) {
      const last = chunks[chunks.length - 1];
      const overflow = last.length + totals.length - ROWS_PER_PAGE;
      if (overflow > 0) {
        const move = Math.min(overflow, last.length);
        chunks.push(last.splice(last.length - move, move));
      }
      chunks[chunks.length - 1].push(...totals);
    }

    for (const rows of chunks) {
      sheets.push({ tableTitle: group.tableTitle, rows });
    }
  }

  return sheets;
}
